/*
 * Module for the _PropTransactionList partial view
 */
rs.module("ui/content/account/overview/proptransactionlist",

    [],

    function () {

        function initialize(listApi, backendUrls, propAccountKey) {

            listApi.onItemClick(function (e, context) {

                listApi.detail.updateTitle("Transaction Details");

                $.get(
                    backendUrls.getPropTransactionDetail,
                    {
                        propAccountKey: propAccountKey,
                        propTransactionKey: context.PropTransactionKey
                    }
                ).done(function (html) {
                    listApi.detail.loadDetail(html);
                }).fail(function () {
                    listApi.detail.clearDetail();
                });
            });
        }

        var exports = {
            initialize: initialize
        };

        return exports;
    }
);
